import { render, staticRenderFns } from "./FooterLoadPlaceholder.vue?vue&type=template&id=67e0865c&scoped=true"
import script from "./FooterLoadPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterLoadPlaceholder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterLoadPlaceholder.vue?vue&type=style&index=0&id=67e0865c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e0865c",
  null
  
)

export default component.exports